<template>
  <div id="PrivacyPolicy">
    <div class="title">Privacy Policy</div>
    <div class="flex_box">
      <div class="text">
Convenience Cash Lending Corp.,  a corporation duly organized and existing
under the laws of the Republic of the Philippines enacts this Privacy
Policy to clarify what information we collect, why we
collect it, and how you can update, manage, export, and delete your
information.
      </div>
      <div class="btn" @click="handleGoogle()">VIEW</div>
      <!-- <div class="type_box">
        <div class="type_item google" @click="handleGoogle()"></div>
        <div class="type_item apple" @click="handleApple()"></div>
      </div> -->
    </div>
    <div class="about_list">
      <div class="about_item">
        <div class="pic">
          <img src="./../assets/about_us1.png" alt="" />
        </div>
        <div class="text">
Our company was certified by the SEC in 2020.
Company name: Convenience Cash Lending Corp.
SEC Registration No. 2020090002200-05
Registered Business Name: Zada Cash CERTIFICATE OF AUTHORITY NO.3319
        </div>
      </div>
      <div class="about_item">
        <div class="pic">
          <img src="./../assets/about_us2.png" alt="" />
        </div>
        <div class="text">
We value confidentiality and integrity to our customer's information.
        </div>
      </div>
      <div class="about_item">
        <div class="pic">
          <img src="./../assets/about_us3.png" alt="" />
        </div>
        <div class="text">
We are adhering to the Makati city's rules and requlations in running.
Our company while being transparent to our customers.
        </div>
      </div>
    </div>
    <div class="name">ZADA CASH</div>
    <div class="flex_box mt_18">
      <div class="left_slogen">A trusted partner</div>
      <div class="message">
        <div class="email">cs@phzada.com</div>
        <div class="tel">9615235087</div>
        <!-- <div class="msg">09171398778</div> -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  created() {},
  methods: {
    handleGoogle() {
      window.open(
        "https://mobile.phzada.com/agreementList_detail?name=Privacy%20Policy&type=android",
        "_blank"
      );
    },
    handleApple() {
      window.open(
        "https://mobile.phzada.com/agreementList_detail?name=Privacy%20Policy&type=ios",
        "_blank"
      );
    },
  },
};
</script>

<style lang="scss" scoped>
#PrivacyPolicy {
  margin-top: 200px;
  background-color: #f6f6f6;
  width: 100%;
  box-sizing: border-box;
  padding: 120px 176px;
  .title {
    font-family: "Lexend_Medium";
    font-weight: 500;
    font-size: 61px;
    color: #000000;
    line-height: 79px;
  }
  .flex_box {
    display: flex;
    justify-content: space-between;
    margin-top: 23px;
    .text {
      width: 827px;
      font-family: "Lexend_Light";
      font-weight: 300;
      font-size: 19px;
      color: #000000;
      line-height: 29px;
    }
    .btn {
      width: 187px;
      height: 60px;
      font-family: 'Lexend_Regular';
      font-weight: bold;
      font-size: 18px;
      color: #29281E;
      text-align: center;
      line-height: 60px;
      border-radius: 60px;
      border: 2px solid #29281E;
      box-sizing: border-box;
      cursor: pointer;
    }
    .type_box {
      display: flex;
      align-items: flex-end;
      .type_item {
        width: 80px;
        height: 80px;
        cursor: pointer;
      }
      .google {
        background: url("./../assets/google.png") 0 0 no-repeat;
        background-size: 100% 100%;
        margin-right: 16px;
      }
      .apple {
        background: url("./../assets/apple.png") 0 0 no-repeat;
        background-size: 100% 100%;
      }
    }
  }
  .about_list {
    display: flex;
    justify-content: space-between;
    margin-top: 33px;
    .about_item {
      width: 395px;
      height: 373px;
      padding: 25px 20px 0;
      box-sizing: border-box;
      font-family: "Lexend_Light";
      font-weight: 300;
      font-size: 16px;
      color: #000000;
      line-height: 25px;
      background-color: #fff;
      border-radius: 36px;
      .pic {
        width: 217px;
        height: 129px;
      }
      .text {
        white-space: pre-wrap;
      }
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
  .name {
    margin-top: 146px;
    font-family: "Lexend_SemiBold";
    font-weight: 500;
    font-size: 36px;
    color: #0078ff;
    line-height: 55px;
  }
  .mt_18 {
    margin-top: 18px;
    .left_slogen {
      font-family: "Lexend_SemiBold";
      font-weight: 600;
      font-size: 49px;
      color: #4b595d;
      line-height: 67px;
    }
    .message {
      line-height: 67px;
      display: flex;
      justify-content: end;
      font-family: "Lexend_Light";
      font-weight: 300;
      font-size: 19px;
      color: #4b595d;
      line-height: 70px;
      .email {
        margin-right: 97px;
        position: relative;
        &::before {
          content: "";
          position: absolute;
          width: 22px;
          height: 22px;
          background: url("./../assets/email.png") 0 0 no-repeat;
          background-size: 100% 100%;
          left: -34px;
          top: 26px;
        }
      }
      .tel {
        margin-right: 97px;
        position: relative;
        &::before {
          content: "";
          position: absolute;
          width: 22px;
          height: 22px;
          background: url("./../assets/tel.png") 0 0 no-repeat;
          background-size: 100% 100%;
          left: -34px;
          top: 25px;
        }
      }
      .msg {
        position: relative;
        &::before {
          content: "";
          position: absolute;
          width: 22px;
          height: 22px;
          background: url("./../assets/message.png") 0 0 no-repeat;
          background-size: 100% 100%;
          left: -34px;
          top: 25px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/PrivacyPolicy.vue